// Mock data for AlertPilot clone

export const arbitrageOpportunities = [
  {
    id: 1,
    marketPair: 'Polymarket//Opinion',
    title: 'Bitcoin above $150K by end of quarter?',
    volume: '$38M',
    score: 97.3,
    spread: 1.30,
    ev: 1507,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.45 },
    platform2Price: { type: 'NO', price: 0.55 },
    combinedCost: 0.915,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.78, reasons: ['Strong momentum', 'High volume'] }
  },
  {
    id: 2,
    marketPair: 'Polymarket//Opinion',
    title: 'Fed rate cut at the next FOMC meeting?',
    volume: '$39M',
    score: 96.9,
    spread: 1.00,
    ev: 630,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'NO', price: 0.58 },
    platform2Price: { type: 'YES', price: 0.342 },
    combinedCost: 0.922,
    verified: true,
    signal: { direction: 'SELL', confidence: 0.65, reasons: ['Mean reversion signal', 'Orderbook imbalance'] }
  },
  {
    id: 3,
    marketPair: 'Polymarket//Opinion',
    title: 'Will SpaceX IPO this year?',
    volume: '$27M',
    score: 87.2,
    spread: 0.60,
    ev: 355,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.32 },
    platform2Price: { type: 'NO', price: 0.628 },
    combinedCost: 0.948,
    verified: true,
    signal: { direction: 'NEUTRAL', confidence: 0.42, reasons: ['Low confidence', 'Mixed signals'] }
  },
  {
    id: 4,
    marketPair: 'Polymarket//Kalshi',
    title: 'Will the ECB cut rates at its next meeting?',
    volume: '$25M',
    score: 96.8,
    spread: 1.20,
    ev: 1021,
    platform1: 'Polymarket',
    platform2: 'Kalshi',
    platform1Price: { type: 'NO', price: 0.63 },
    platform2Price: { type: 'YES', price: 0.279 },
    combinedCost: 0.909,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.72, reasons: ['Strong momentum', 'Volume spike'] }
  },
  {
    id: 5,
    marketPair: 'Polymarket//Opinion',
    title: 'Trump announces new Cabinet position this week?',
    volume: '$22M',
    score: 94.5,
    spread: 1.85,
    ev: 892,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.38 },
    platform2Price: { type: 'NO', price: 0.58 },
    combinedCost: 0.960,
    verified: true,
    signal: { direction: 'NEUTRAL', confidence: 0.48, reasons: ['Mixed signals'] }
  },
  {
    id: 6,
    marketPair: 'Polymarket//Kalshi',
    title: 'Ethereum above $4000 by end of month?',
    volume: '$31M',
    score: 95.2,
    spread: 1.45,
    ev: 1156,
    platform1: 'Polymarket',
    platform2: 'Kalshi',
    platform1Price: { type: 'YES', price: 0.52 },
    platform2Price: { type: 'NO', price: 0.46 },
    combinedCost: 0.980,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.81, reasons: ['Momentum: 0.88', 'Acceleration: 0.75', 'High volume'] }
  },
  {
    id: 7,
    marketPair: 'Polymarket//Opinion',
    title: 'Tesla stock above $300 by end of quarter?',
    volume: '$18M',
    score: 93.8,
    spread: 1.60,
    ev: 743,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.41 },
    platform2Price: { type: 'NO', price: 0.57 },
    combinedCost: 0.980,
    verified: true,
    signal: { direction: 'SELL', confidence: 0.68, reasons: ['Mean reversion', 'Overextended'] }
  },
  {
    id: 8,
    marketPair: 'Polymarket//Opinion',
    title: 'US GDP growth above 3% this quarter?',
    volume: '$14M',
    score: 91.4,
    spread: 1.90,
    ev: 658,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'NO', price: 0.55 },
    platform2Price: { type: 'YES', price: 0.42 },
    combinedCost: 0.970,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.59, reasons: ['Orderbook imbalance'] }
  },
  {
    id: 9,
    marketPair: 'Polymarket//Kalshi',
    title: 'NVIDIA stock above $1000 by end of quarter?',
    volume: '$29M',
    score: 96.1,
    spread: 1.25,
    ev: 1089,
    platform1: 'Polymarket',
    platform2: 'Kalshi',
    platform1Price: { type: 'YES', price: 0.48 },
    platform2Price: { type: 'NO', price: 0.51 },
    combinedCost: 0.990,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.76, reasons: ['Strong momentum', 'Volume confirmation'] }
  },
  {
    id: 10,
    marketPair: 'Polymarket//Opinion',
    title: 'Apple announces new product category this quarter?',
    volume: '$12M',
    score: 89.7,
    spread: 2.15,
    ev: 512,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.35 },
    platform2Price: { type: 'NO', price: 0.63 },
    combinedCost: 0.980,
    verified: true,
    signal: { direction: 'NEUTRAL', confidence: 0.44, reasons: ['Low confidence'] }
  },
  {
    id: 11,
    marketPair: 'Polymarket//Kalshi',
    title: 'S&P 500 at a new all-time high by end of month?',
    volume: '$35M',
    score: 97.5,
    spread: 0.95,
    ev: 1423,
    platform1: 'Polymarket',
    platform2: 'Kalshi',
    platform1Price: { type: 'YES', price: 0.56 },
    platform2Price: { type: 'NO', price: 0.43 },
    combinedCost: 0.990,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.84, reasons: ['Momentum: 0.91', 'Acceleration: 0.82'] }
  },
  {
    id: 12,
    marketPair: 'Polymarket//Opinion',
    title: 'New frontier AI model released this month?',
    volume: '$16M',
    score: 92.3,
    spread: 1.75,
    ev: 721,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'NO', price: 0.51 },
    platform2Price: { type: 'YES', price: 0.47 },
    combinedCost: 0.980,
    verified: true,
    signal: { direction: 'SELL', confidence: 0.63, reasons: ['Overextended up'] }
  },
  {
    id: 13,
    marketPair: 'Polymarket//Kalshi',
    title: 'Bitcoin dominance below 50% by end of quarter?',
    volume: '$21M',
    score: 94.8,
    spread: 1.35,
    ev: 894,
    platform1: 'Polymarket',
    platform2: 'Kalshi',
    platform1Price: { type: 'YES', price: 0.44 },
    platform2Price: { type: 'NO', price: 0.54 },
    combinedCost: 0.980,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.71, reasons: ['Strong momentum'] }
  },
  {
    id: 14,
    marketPair: 'Polymarket//Opinion',
    title: 'Major tech layoffs announced this week?',
    volume: '$9M',
    score: 88.2,
    spread: 2.40,
    ev: 387,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.32 },
    platform2Price: { type: 'NO', price: 0.66 },
    combinedCost: 0.980,
    verified: true,
    signal: { direction: 'NEUTRAL', confidence: 0.41, reasons: ['Insufficient data'] }
  },
  {
    id: 15,
    marketPair: 'Polymarket//Kalshi',
    title: 'Gold at a new all-time high by end of quarter?',
    volume: '$24M',
    score: 95.9,
    spread: 1.10,
    ev: 1012,
    platform1: 'Polymarket',
    platform2: 'Kalshi',
    platform1Price: { type: 'YES', price: 0.49 },
    platform2Price: { type: 'NO', price: 0.50 },
    combinedCost: 0.990,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.77, reasons: ['Volume spike', 'Momentum'] }
  },
  {
    id: 16,
    marketPair: 'Polymarket//Opinion',
    title: 'Major crypto exchange lists new altcoin this week?',
    volume: '$11M',
    score: 90.1,
    spread: 2.05,
    ev: 589,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'NO', price: 0.53 },
    platform2Price: { type: 'YES', price: 0.45 },
    combinedCost: 0.980,
    verified: true,
    signal: { direction: 'SELL', confidence: 0.61, reasons: ['Mean reversion signal'] }
  },
  {
    id: 17,
    marketPair: 'Polymarket//Kalshi',
    title: 'Unemployment rate below 4% in next jobs report?',
    volume: '$19M',
    score: 93.6,
    spread: 1.55,
    ev: 812,
    platform1: 'Polymarket',
    platform2: 'Kalshi',
    platform1Price: { type: 'YES', price: 0.47 },
    platform2Price: { type: 'NO', price: 0.52 },
    combinedCost: 0.990,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.69, reasons: ['Acceleration positive'] }
  },
  {
    id: 18,
    marketPair: 'Polymarket//Opinion',
    title: 'Major sports upset this weekend?',
    volume: '$8M',
    score: 87.4,
    spread: 2.60,
    ev: 321,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.29 },
    platform2Price: { type: 'NO', price: 0.69 },
    combinedCost: 0.980,
    verified: true,
    signal: { direction: 'NEUTRAL', confidence: 0.39, reasons: ['Low confidence'] }
  },
  {
    id: 19,
    marketPair: 'Polymarket//Kalshi',
    title: 'Oil price above $90 per barrel by end of month?',
    volume: '$27M',
    score: 96.3,
    spread: 1.15,
    ev: 1134,
    platform1: 'Polymarket',
    platform2: 'Kalshi',
    platform1Price: { type: 'YES', price: 0.51 },
    platform2Price: { type: 'NO', price: 0.48 },
    combinedCost: 0.990,
    verified: true,
    signal: { direction: 'BUY', confidence: 0.79, reasons: ['Strong momentum', 'High volume'] }
  },
  {
    id: 20,
    marketPair: 'Polymarket//Opinion',
    title: 'New meme coin reaches top 100 by market cap?',
    volume: '$13M',
    score: 91.8,
    spread: 1.80,
    ev: 687,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'NO', price: 0.54 },
    platform2Price: { type: 'YES', price: 0.44 },
    combinedCost: 0.980,
    verified: true,
    signal: { direction: 'SELL', confidence: 0.66, reasons: ['Overextended', 'Volume declining'] }
  },
  {
    id: 5,
    marketPair: 'Polymarket//Opinion',
    title: 'Will the Broncos win the AFC Championship?',
    volume: '$16M',
    score: 97.1,
    spread: 1.30,
    ev: 736,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.35 },
    platform2Price: { type: 'NO', price: 0.62 },
    combinedCost: 0.957,
    verified: true
  },
  {
    id: 6,
    marketPair: 'Polymarket//Probable',
    title: 'Rainbow FDV above $400M one day after launch?',
    volume: '$14M',
    score: 97.0,
    spread: 1.30,
    ev: 1220,
    platform1: 'Polymarket',
    platform2: 'Probable',
    platform1Price: { type: 'YES', price: 0.08 },
    platform2Price: { type: 'NO', price: 0.877 },
    combinedCost: 0.957,
    verified: true
  },
  {
    id: 7,
    marketPair: 'Polymarket//Opinion',
    title: 'Will Trump announce a new Cabinet position?',
    volume: '$4M',
    score: 96.9,
    spread: 1.70,
    ev: 760,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.42 },
    platform2Price: { type: 'NO', price: 0.55 },
    combinedCost: 0.970,
    verified: true
  },
  {
    id: 8,
    marketPair: 'Polymarket//Opinion',
    title: 'New frontier AI model released this quarter?',
    volume: '$4M',
    score: 85.1,
    spread: 2.10,
    ev: 193,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.28 },
    platform2Price: { type: 'NO', price: 0.69 },
    combinedCost: 0.970,
    verified: true
  },
  {
    id: 9,
    marketPair: 'Polymarket//Opinion',
    title: 'Ethereum above $5000 by end of quarter?',
    volume: '$3M',
    score: 97.0,
    spread: 1.10,
    ev: 302,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.45 },
    platform2Price: { type: 'NO', price: 0.52 },
    combinedCost: 0.970,
    verified: true
  },
  {
    id: 10,
    marketPair: 'Polymarket//Opinion',
    title: 'Tesla stock above $400 by end of quarter?',
    volume: '$3M',
    score: 96.9,
    spread: 1.50,
    ev: 1048,
    platform1: 'Polymarket',
    platform2: 'Opinion',
    platform1Price: { type: 'YES', price: 0.38 },
    platform2Price: { type: 'NO', price: 0.59 },
    combinedCost: 0.970,
    verified: true
  }
];

export const heroOpportunity = {
  spread: '+8.5%',
  title: 'Bitcoin Daily Close Above $105k - High Confidence BUY Signal',
  platform1: 'Polymarket',
  platform2: 'Opinion',
  aiVerification: {
    marketMatch: 'Confirmed - Predictive model shows 78% confidence BUY signal based on strong momentum and volume spike',
    closeCondition: 'Stop Loss: -3% | Take Profit: +6% | Signal: STRONG BUY (5 indicators aligned)'
  },
  signal: {
    direction: 'BUY',
    confidence: 0.78,
    reasons: ['Momentum: 0.85', 'Acceleration: 0.72', 'High volume: 0.68', 'Orderbook imbalance: 0.45']
  }
};

export const telegramAlerts = [
  {
    id: 1,
    title: "Will SpaceX's market cap be greater than $1T on IPO day?",
    spread: '+8.50%',
    ev: '$142',
    combinedCost: '$0.915',
    platform1: { name: 'Polymarket', type: 'YES', price: '$0.450' },
    platform2: { name: 'Opinion', type: 'NO', price: '$0.465' },
    time: '09:32'
  },
  {
    id: 2,
    title: 'Bitcoin above $150K by end of quarter?',
    spread: '+5.20%',
    ev: '$52',
    combinedCost: '$0.948',
    platform1: { name: 'Polymarket', type: 'YES', price: '$0.320' },
    platform2: { name: 'Opinion', type: 'NO', price: '$0.628' },
    time: '11:45'
  },
  {
    id: 3,
    title: 'Fed rate cut at the next FOMC meeting?',
    spread: '+7.80%',
    ev: '$78',
    combinedCost: '$0.922',
    platform1: { name: 'Polymarket', type: 'NO', price: '$0.580' },
    platform2: { name: 'Opinion', type: 'YES', price: '$0.342' },
    time: '13:18'
  }
];

// Testimonials removed - contained unverifiable performance claims

export const faqData = [
  {
    id: 1,
    question: 'Do I have to lock my capital until the event ends?',
    answer: 'No. This is a common misconception. While you *can* hold to maturity for the guaranteed payout, most arbitrageurs trade the **Spread Compression**. You buy when the gap is wide (e.g., 15%) and sell when the markets align (e.g., 1%). Most opportunities close in days or weeks, but some can close in minutes or hours.'
  },
  {
    id: 2,
    question: 'How do Exchange Fees impact the arbitrage spread?',
    answer: 'Fees are a friction point but they can be almost entirely mitigated by using Limit Orders (Maker have 0% fees), prioritising Polymarket dominant arbitrages or only taking arbitrages with big enough spreads to cover the fees.'
  },
  {
    id: 3,
    question: 'Can I use this for Airdrop / Points Farming?',
    answer: 'Yes. Many users treat the arbitrage profit as a bonus while their primary goal is generating volume for potential airdrops on newer platforms like Opinion. By hedging your position across two exchanges, you can farm volume while remaining Delta Neutral (market neutral).'
  },
  {
    id: 4,
    question: "Why does the 'Basic' plan have a delay?",
    answer: 'Every tier (Basic, Pro and Advanced) gets live arbitrage data, the only difference is how frequently you can refresh. For beginners or those wishing to test the product Basic can suffice and arbitrages will still be found, but for advanced traders Pro or Advanced tier is recommended.'
  },
  {
    id: 5,
    question: 'What if the AI matches two markets with different rules?',
    answer: "We use a 'Hybrid Verification' system. Our LLM semantic engine compares resolution dates (e.g., 'Jan 1' vs 'Dec 31') and sources. If the rules are not functionally identical, the system flags it. However, you should always verify the 'AI Notes' in the terminal before deploying significant capital."
  }
];

export const terminalLogs = [
  '[10:45:02.112] POLY: Block 458291 processed. 42ms.',
  '[10:45:02.155] OPIN: NewAsk: 0.45. Spread detected.',
  '[10:45:02.201] CORE: AI Job #992 started.',
  '[10:45:02.450] CORE: AI Job #992 finished. Confirmed.',
  '[10:45:02.455] ALERT: Webhook dispatched. Total time: 343ms.',
  '[10:45:02.512] POLY: Polling...'
];
